import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import AdminNav from './AdminNav';
import OfferOverviewStep from './OfferOverviewStep';

const AdminOfferView = () => {
  const { offerId } = useParams();
  const { t } = useTranslation();
  const { getAuthHeaders, logout } = useAuth();
  const [offer, setOffer] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const loadOffer = async () => {
      setIsLoading(true);
      setError('');
      try {
        const response = await fetch(`/api/admin/offers/${offerId}`, {
          headers: getAuthHeaders()
        });

        if (response.status === 401) {
          logout();
          return;
        }

        const data = await response.json();
        if (!response.ok) {
          if (!cancelled) setError(data.error || t('offer.offerNotFound'));
          return;
        }

        if (!cancelled) setOffer(data.offer || null);
      } catch (err) {
        console.error('Error loading offer:', err);
        if (!cancelled) setError(t('offer.failedToLoadOffer'));
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    if (offerId) loadOffer();
    return () => {
      cancelled = true;
    };
  }, [offerId, getAuthHeaders, logout, t]);

  return (
    <div className="container mx-auto px-4 py-8">
      <AdminNav />
      <div className="mb-4">
        <Link to="/admin/conversations" className="text-sm font-medium text-blue-700 hover:text-blue-900">
          {t('admin.conversations.backToConversation')}
        </Link>
      </div>
      <div className="bg-white rounded-lg shadow-sm max-w-2xl">
        {isLoading && (
          <p className="p-6 text-sm text-gray-500">{t('offer.loadingOffer')}</p>
        )}
        {!isLoading && error && (
          <p className="p-6 text-sm text-red-600">{error}</p>
        )}
        {!isLoading && offer && (
          <OfferOverviewStep previewOffer={offer} />
        )}
      </div>
    </div>
  );
};

export default AdminOfferView;
